module.exports = __webpack_public_path__ + "img/offshore-pump.dad43330.png";